export default __webpack_public_path__ + "static/media/eye-white.c3a129a3.svg";